/* corex-textil-editor.js · Personalizador visual de camisetas B2B: flujo sencillo sobre la prenda.
   El cliente sube imágenes y textos y los mueve, escala y gira sobre la camiseta. En delante/detrás los elementos
   cercanos (a menos de 2 cm) forman solos una impresión (corex-textil-editor-groups.js), que se cobra por su caja real;
   en las mangas hay una impresión de 10×10 a una distancia del bajo. Las impresiones resultantes tienen la forma de
   siempre, así que escalado, precios, carrito y archivos no cambian. Zonas por tipo de prenda: corex.zonas.
   Módulos: zones, groups, geo, model, io, draw, ui, align, fonts, text, overlay, pointer. Marcado en
   snippets/corex-textil-editor.liquid. */
(function () {
  'use strict';

  var G = window.CorexTextilGeo, M = window.CorexTextilModel, IO = window.CorexTextilIO, D = window.CorexTextilDraw;
  var UI = window.CorexTextilUI, A = window.CorexTextilAlign, Z = window.CorexTextilZones, GR = window.CorexTextilGroups;
  var F = window.CorexTextilFonts, OV = window.CorexTextilOverlay, W = window;
  if (!G || !M || !IO || !D || !UI || !A || !Z || !GR || !F || !OV || !W.CorexTextilText || !W.CorexTextilPointer || !W.CorexTextilGarment || !W.CorexTextilExport || !W.CorexTextilSizing || !W.CorexTextilSizeUI) return;

  var fmt = IO.fmt, round = IO.round;
  var DIST_MAX = 60;
  var DX_MAX = 40;
  var IMAGE_W_MIN = 0.5;
  var IMAGE_W_MAX = 80;
  var TEXT_MIN = 0.3;
  var TEXT_MAX = 40;
  var NEW_LAYER_FILL = 0.6;
  var MIN_DPI = 150;
  var NEW_GAP_CM = 1; /* un elemento nuevo va a esta distancia bajo el diseño de la zona (< 2 cm: se imprime con él) */
  var SLEEVE_FORESHORTEN = 0.45;
  var STATUS_MS = 5000;
  /* Delante/detrás: caja típica para dimensionar elementos nuevos (un logo delante, un diseño estándar detrás). */
  var DEFAULT_BOX = { front: '10x10', back: '30x40' };

  function init(root) {
    if (root.dataset.cteReady) return;
    var twin = document.querySelector('.cte.is-mounted[id="' + root.id + '"]');
    if (twin && twin !== root) { root.remove(); return; }
    root.dataset.cteReady = '1';
    /* Fuera de la columna de compra: debajo de la sección del producto, a todo el ancho. */
    var section = root.closest('.shopify-section');
    if (section && section.parentNode) section.parentNode.insertBefore(root, section.nextSibling);
    root.classList.add('is-mounted');

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var data;
    try { data = JSON.parse(q('[data-cte-data]').textContent); } catch (e) { data = null; }
    var sizesOrder = data && data.medidas ? Object.keys(data.medidas) : [];
    /* Sin calibración solo se abre si el producto tiene nivel (corex.nivel): entonces la vista previa usa la silueta plana. */
    if (!data || !sizesOrder.length || (!data.calibracion && !data.nivel) || !(data.colors || []).length) {
      q('[data-cte-lock-msg]').textContent = 'Este producto aún no tiene medidas o calibración de foto: no se puede abrir el editor.';
      q('[data-cte-lock]').hidden = false;
      return;
    }
    /* Orden de tallas del producto (corex.variants_full): base del escalado por tallas. */
    var productSizes = (data.variants || []).reduce(function (acc, v) {
      if (acc.indexOf(v.talla) === -1) acc.push(v.talla);
      return acc;
    }, []);
    if (!productSizes.length) productSizes = sizesOrder;
    var zoneCfg = Z.zonesFor(data.zonas);
    /* Tipo de prenda (corex.prenda): plantilla de la silueta plana del editor y sus zonas (sin mangas si no tiene). */
    var prenda = window.CorexTextilPrendas.get(data.prenda);
    var prendaMeds = sizesOrder.map(function (t) { return data.medidas[t]; }).filter(Boolean);
    var prendaTpl = window.CorexTextilFlat.template(prenda.template, prendaMeds);
    var VIEWS = window.CorexTextilPrendas.viewsFor(prenda, zoneCfg.zonas, !prendaTpl || prendaTpl.hasSleeves(), prendaTpl ? prendaTpl.cuffCm : 0);
    var VIEW = VIEWS.reduce(function (acc, v) { acc[v.id] = v; return acc; }, {});
    var cal = G.calibration(data.calibracion);
    /* La foto lateral (corex.packshots side) muestra una manga; la otra vista usa la misma foto en espejo. */
    var SLEEVE_VIEWS = VIEWS.filter(function (v) { return v.kind === 'sleeve'; });
    var SIDE_PHOTO_VIEW = !SLEEVE_VIEWS.length ? null : (cal.manga && cal.manga.lado === 'izquierda' ? SLEEVE_VIEWS[0] : SLEEVE_VIEWS[SLEEVE_VIEWS.length - 1]).id;
    var uiFont = getComputedStyle(document.documentElement).getPropertyValue('--main_ff').trim() || 'sans-serif';
    var free = M.printSize(M.FREE_AREA);

    var canvas = q('[data-cte-canvas]'), sheet = q('[data-cte-sheet]');
    var ctx = canvas.getContext('2d');
    var layerCanvases = {}, flatCache = {}, images = {}, printsMemo = {};
    var metrics = null;   /* { frame, s, tf, kind, cmPerPx, items: [{ print, area, cv }], cota } */
    var rafId = 0, statusTimer = 0, fontsVersion = 0, dragging = false;
    /* Cotas de la prenda (interruptor «Ver medidas de la prenda») y transición de la silueta al cambiar de talla. */
    /* Sudaderas con capucha: la capucha de detrás va encima del diseño. hoodMode: 'media' (50 %), 'entera' (100 %) u
       'oculta'; mientras se arrastra o escala un diseño baja a HOOD_DRAG_ALPHA para ver lo que hay debajo. */
    var HOOD_ALPHA = { media: 0.5, entera: 1, oculta: 0 }, HOOD_NEXT = { media: 'entera', entera: 'oculta', oculta: 'media' };
    var HOOD_DRAG_ALPHA = 0.1, hoodMode = 'media';
    function hoodAlpha() { return hoodMode === 'oculta' ? 0 : dragging ? HOOD_DRAG_ALPHA : HOOD_ALPHA[hoodMode]; }
    var showMeasures = true, GARMENT_ANIM_MS = 260, garmentAnim = null, shownMed = null, animRaf = 0;
    var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var sheetOpener = null;

    var firstColor = data.colors.filter(function (c) { return c.photo; })[0] || data.colors[0];
    var state = {
      color: firstColor.name, size: null, tab: VIEWS[0].id, printId: null, sel: null, selIds: [],
      views: VIEWS.reduce(function (acc, v) { acc[v.id] = { items: [], dist: v.kind === 'sleeve' ? v.defaultDist : null }; return acc; }, {})
    };

    /* ---------- estado (copias nuevas en cada cambio) ---------- */
    function setState(patch) { state = Object.assign({}, state, patch); update(); }
    function withView(viewId, patch) {
      var views = Object.assign({}, state.views);
      views[viewId] = Object.assign({}, state.views[viewId], patch);
      return views;
    }
    function vdef(id) { return VIEW[id || state.tab] || null; }
    function isFlat(viewId) { return VIEW[viewId].kind !== 'sleeve'; }
    function itemsOf(viewId) { return state.views[viewId || state.tab].items; }
    function hasDesign(viewId) { return itemsOf(viewId).length > 0; }
    function activeViews() { return VIEWS.filter(function (v) { return hasDesign(v.id); }); }
    function sleevePrint(viewId) {
      return { id: viewId + '-1', size: M.SLEEVE_SIZE, dist: state.views[viewId].dist, dx: 0, layers: itemsOf(viewId) };
    }
    /* Impresiones de una vista: delante/detrás, los grupos de elementos; manga, la de 10×10 si tiene algo. */
    function prints(viewId) {
      var id = viewId || state.tab, items = itemsOf(id);
      if (!items.length) return [];
      if (!isFlat(id)) return [sleevePrint(id)];
      var memo = printsMemo[id];
      if (memo && memo.items === items && memo.fv === fontsVersion) return memo.prints;
      var list = GR.derivePrints({ viewId: id, items: items, corners: G.layerCorners, size: M.FREE_AREA, areaH: free.h });
      printsMemo[id] = { items: items, fv: fontsVersion, prints: list };
      return list;
    }
    /* Contenedor que se edita en la zona: delante/detrás, todos los elementos en cm de prenda (área centrada en el
       cuello y el eje, así que las coordenadas locales son las de la prenda); manga, la impresión de 10×10. */
    function editPrint(viewId) {
      var id = viewId || state.tab;
      if (!isFlat(id)) return sleevePrint(id);
      return { id: 'edit-' + id, size: M.FREE_AREA, dist: -free.h / 2, dx: 0, layers: itemsOf(id) };
    }
    function activePrint() { return state.tab ? editPrint() : null; }
    /* Nombre interno de la impresión (carrito: "Delante I2" sale de aquí; revisión: "Diseño 2"). */
    function printName(viewId, p) {
      return isFlat(viewId) ? 'Impresión ' + (prints(viewId).indexOf(p) + 1) : VIEW[viewId].long;
    }
    /* Nombre visible: "El diseño" si en la zona hay uno; si hay varios, "Diseño 2". */
    function shownName(viewId, nombre) {
      if (!isFlat(viewId)) return 'El diseño';
      return prints(viewId).length > 1 ? String(nombre).replace(/^Impresión\b/, 'Diseño') : 'El diseño';
    }
    function setItems(items, extra) { setState(Object.assign({ views: withView(state.tab, { items: items }) }, extra || {})); }
    function patchLayer(id, patch) {
      setItems(itemsOf().map(function (l) { return l.id === id ? Object.assign({}, l, patch) : l; }));
    }
    /* Arrastres: cambia el estado sin rehacer el resto de controles. */
    function patchLayerLive(id, patch) {
      state = Object.assign({}, state, { views: withView(state.tab, { items: itemsOf().map(function (l) { return l.id === id ? Object.assign({}, l, patch) : l; }) }) });
      updateLight();
    }
    function shiftLayers(deltas) {
      setItems(itemsOf().map(function (l) {
        var d = deltas[l.id];
        return d ? Object.assign({}, l, { x: round(l.x + d.dx, 3), y: round(l.y + d.dy, 3) }) : l;
      }));
    }
    /* Límites para mover (cm de la zona, talla de referencia). Delante/detrás: ancho útil (½ pecho − CHEST_MARGIN_CM/2
       a cada lado del eje) y largo útil (de NECK_MARGIN_CM bajo el cuello al bajo − HEM_MARGIN_CM). Mangas: su impresión de 10×10. */
    function moveLimits() {
      var a = areaOf(state.tab, editPrint());
      if (!isFlat(state.tab)) return { x0: -a.w / 2, x1: a.w / 2, y0: -a.h / 2, y1: a.h / 2 };
      return GM.useful(state.tab, state.size, { chest: M.CHEST_MARGIN_CM, hem: M.HEM_MARGIN_CM, neck: M.NECK_MARGIN_CM, armhole: M.ARMHOLE_MARGIN_CM });
    }
    /* Posición { x, y } de la capa l movida a patch, con tope: su caja no sale de moveLimits(). */
    function clampMove(l, patch) {
      var moved = Object.assign({}, l, patch), s = A.clampShift(A.boxOf(G.layerCorners(moved)), moveLimits());
      return { x: round(moved.x + s.dx, 2), y: round(moved.y + s.dy, 2) };
    }
    function selected() { return itemsOf().filter(function (l) { return l.id === state.sel; })[0] || null; }
    /* Selección múltiple (Mayús/Ctrl/Cmd + clic): state.selIds; state.sel es el elemento principal. */
    function selectedIds() {
      if (!state.sel) return [];
      var ids = (state.selIds || []).indexOf(state.sel) !== -1 ? state.selIds : [state.sel];
      return ids.filter(function (id) { return itemsOf().some(function (l) { return l.id === id; }); });
    }
    function selectOnly(printId, id) { setState({ printId: printId, sel: id, selIds: id ? [id] : [] }); }
    function toggleSel(printId, id) {
      var ids = selectedIds(), on = ids.indexOf(id) !== -1;
      var next = on ? ids.filter(function (x) { return x !== id; }) : ids.concat([id]);
      setState({ printId: printId, sel: on ? (next[next.length - 1] || null) : id, selIds: next });
    }
    function isMulti(e) { return !!(e && (e.shiftKey || e.ctrlKey || e.metaKey)); }
    /* Impresión de la zona a la que se refieren la cota y la barra: la del elemento seleccionado o la primera. */
    function activeGroup() {
      var list = prints();
      if (!list.length) return null;
      if (!isFlat(state.tab)) return list[0];
      return list.filter(function (p) { return p.itemIds.indexOf(state.sel) !== -1; })[0] || list[0];
    }
    function medFor(size) { return data.medidas[size] || data.medidas[sizesOrder[Math.floor(sizesOrder.length / 2)]]; }
    function med() { return medFor(state.size); }
    /* Color con el que se pinta la prenda: el del editor o, al exportar la vista previa de otro color, ese. */
    var paintOverride = null;
    function paintColor() { return paintOverride || state.color; }
    function garmentColor() { return GM.color(); }
    function areaOf(viewId, p) { return G.printArea(VIEW[viewId].kind, p, med()); }
    /* Rectángulo del diseño en cm de prenda (talla de referencia): delante/detrás, caja de las capas visibles;
       mangas, la impresión de 10×10. */
    function designRect(viewId, p) {
      var a = areaOf(viewId, p);
      if (!isFlat(viewId)) return a;
      var b = G.designBounds(p.layers), cv = G.areaCenterV(a);
      if (b && b.w > 0) return { w: b.w, h: b.h, top: cv + b.cy - b.h / 2, cu: a.cu + b.cx, empty: false };
      return { w: 0, h: 0, top: cv, cu: a.cu, empty: true };
    }
    /* Área mínima centrada en el ancla, para el render plano (no reservar 40×50 de lienzo por impresión). */
    function renderArea(viewId, p) {
      var a = areaOf(viewId, p);
      return isFlat(viewId) ? { w: 0, h: 0, top: G.areaCenterV(a), cu: a.cu } : a;
    }
    function billingTalla() { return state.tallaCobro || state.size; }
    function announce(msg) {
      var el = q('[data-cte-status]');
      el.textContent = msg;
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { el.textContent = ''; }, STATUS_MS);
    }

    /* ---------- prenda: fotos (corex-textil-editor-garment.js) ---------- */
    var GM = window.CorexTextilGarment.create({
      data: data, cal: cal, template: prenda.template, view: function (id) { return VIEW[id]; }, sideView: SIDE_PHOTO_VIEW, medFor: medFor, sizes: productSizes,
      paintColor: paintColor, onChange: function () { update(); }
    });
    var frameFor = GM.frameFor, drawBase = GM.drawBase, maskWith = GM.maskWith;
    /* Fotos reales del color elegido (corex-textil-editor-fotos.js): bloque «Fotos del producto», miniatura y visor. */
    var FOTOS = window.CorexTextilFotos ? window.CorexTextilFotos.attach({ root: root, data: data }) : null;
    /* { talla: límites } de una vista; sudaderas: con su zona útil (canalé, bolsillo, cremallera). */
    function limitsBySize(viewId) {
      var lims = GM.limitsBySize(viewId);
      if (!GM.zoned || !isFlat(viewId)) return lims;
      return Object.keys(lims).reduce(function (acc, t) {
        acc[t] = Object.assign({}, lims[t], { zone: GM.useful(viewId, t, { chest: M.CHEST_MARGIN_CM, hem: M.HEM_MARGIN_CM, neck: M.NECK_MARGIN_CM, armhole: M.ARMHOLE_MARGIN_CM }) });
        return acc;
      }, {});
    }
    /* Vistas de un lado de la prenda: delante (o los dos pechos de la cremallera) y detrás. */
    function viewsOfKind(kind) { return VIEWS.filter(function (v) { return v.kind === kind; }); }
    function garmentLimitsBySize(kind) { return GM.garmentLimits(kind); }
    /* Máximo del diseño en la talla de referencia (top: su distancia al cuello). */
    function refLimit(viewId, top) { return M.sizeLimit(VIEW[viewId].kind, med(), limitsBySize(viewId)[state.size], top); }

    /* ---------- móvil (≤ 900 px, como el CSS): colores plegados a 3 filas y guía a la talla ---------- */
    var MSG_TALLA = 'Elige tu talla para empezar a diseñar';
    var MQ_MOVIL = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
    var coloresAbiertos = false, needTimer = 0;
    function esMovil() { return !!(MQ_MOVIL && MQ_MOVIL.matches); }
    /* Más de 3 filas de colores: se ven 3 (con el elegido siempre dentro) y «Ver los N colores» despliega el resto. */
    function plegarColores() {
      var box = q('[data-cte-colors]'), btn = q('.cte-morecolors:not(.cte-morecolors--top)'), top = q('.cte-morecolors--top'), sws = box.querySelectorAll('.cte-sw');
      var tpl = esMovil() ? getComputedStyle(box).gridTemplateColumns : 'none';
      var cols = tpl && tpl !== 'none' ? tpl.split(' ').filter(Boolean).length : 0, max = cols * 3;
      var plegar = cols > 0 && sws.length > max, cerrado = plegar && !coloresAbiertos, elegido = -1;
      [].forEach.call(sws, function (b, i) { if (b.classList.contains('is-on')) elegido = i; });
      var hasta = elegido >= max ? max - 1 : max;
      [].forEach.call(sws, function (b, i) { b.classList.toggle('is-plegado', cerrado && i >= hasta && i !== elegido); });
      btn.hidden = !plegar;
      btn.textContent = coloresAbiertos ? 'Ver menos colores ▴' : 'Ver los ' + sws.length + ' colores ▾';
      btn.setAttribute('aria-expanded', coloresAbiertos ? 'true' : 'false');
      /* desplegados: otro «Ver menos colores» fijo arriba de la zona de colores mientras se ve (bajo la cabecera fija de la tienda) */
      top.hidden = !(plegar && coloresAbiertos);
      fijarArriba();
    }
    /* Alto de la cabecera fija de la tienda (lo que hay fijo arriba de la pantalla), para que el botón quede debajo. */
    function altoCabecera() {
      /* puede haber varias franjas fijas seguidas (aviso, logo, buscador): se baja de una en una */
      var y = 0, top = q('.cte-morecolors--top');
      for (var i = 0; i < 5; i++) {
        /* el fondo es lo más bajo del camino hasta lo fijo (el buscador del tema sobresale de la cabecera fija) */
        var el = document.elementFromPoint(window.innerWidth / 2, y + 2), fondo = 0, bajo = 0;
        while (el && el !== document.body && el !== document.documentElement && !(top && top.contains(el))) {
          bajo = Math.max(bajo, el.getBoundingClientRect().bottom);
          var pos = getComputedStyle(el).position;
          if (pos === 'fixed' || pos === 'sticky') { fondo = Math.round(Math.max(bajo, el.getBoundingClientRect().bottom)); break; }
          el = el.parentElement;
        }
        if (fondo <= y) break;
        y = fondo;
      }
      return y;
    }
    /* (position: sticky no sirve: un contenedor del tema tiene overflow: hidden) mientras la zona de colores pasa por
       debajo de la cabecera, el botón se fija ahí con position: fixed; al salir de la zona vuelve a su sitio. */
    var fijarRaf = 0;
    function fijarArriba() {
      if (fijarRaf) return;
      fijarRaf = requestAnimationFrame(function () {
        fijarRaf = 0;
        var top = q('.cte-morecolors--top'), blk = q('.cte-block--colors');
        var cab = altoCabecera(), r = blk.getBoundingClientRect();
        var fijo = !top.hidden && r.top < cab + 6 && r.bottom > cab + 110;
        blk.classList.toggle('is-fijo', fijo);
        top.style.top = fijo ? cab + 8 + 'px' : '';
        top.style.right = fijo ? Math.max(8, Math.round(window.innerWidth - r.right)) + 'px' : '';
      });
    }
    window.addEventListener('scroll', function () { if (coloresAbiertos && esMovil()) fijarArriba(); }, { passive: true });
    /* Sin talla: lleva a las tallas, las resalta y da un aviso breve. */
    function pedirTalla() {
      var blk = q('.cte-block--sizes'), need = q('[data-cte-need-size]');
      blk.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
      blk.classList.remove('is-flash'); void blk.offsetWidth; blk.classList.add('is-flash');
      need.hidden = false;
      clearTimeout(needTimer);
      needTimer = setTimeout(function () { need.hidden = true; blk.classList.remove('is-flash'); }, 4000);
      var first = blk.querySelector('[data-cte-size]:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
    function alCambiarAncho() { plegarColores(); syncLock(); }
    if (MQ_MOVIL) { if (MQ_MOVIL.addEventListener) MQ_MOVIL.addEventListener('change', alCambiarAncho); else if (MQ_MOVIL.addListener) MQ_MOVIL.addListener(alCambiarAncho); }
    window.addEventListener('resize', plegarColores);

    /* ---------- bloqueo ---------- */
    function lockReason() {
      if (!zoneCfg.calibrado || !prenda.ready) return 'Este tipo de prenda aún no se puede personalizar aquí.';
      /* sin talla no se diseña: todo se dibuja a escala real de la talla elegida */
      if (!state.size) return MSG_TALLA;
      var g = GM.get(state.color);
      if (!g || !g.ready) return 'Cargando las fotos de la prenda…';
      return '';
    }

    /* ---------- render ---------- */
    function requestRender() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () { rafId = 0; renderEditor(); renderPreviews(); });
    }
    function sizeCanvas(cv, cssW, cssH) {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round(cssW * dpr), h = Math.round(cssH * dpr);
      if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
      cv.style.width = cssW + 'px';
      cv.style.height = cssH + 'px';
      return dpr;
    }
    function layerCanvasFor(key, target) {
      var lcv = layerCanvases[key] || (layerCanvases[key] = document.createElement('canvas'));
      if (lcv.width !== target.width || lcv.height !== target.height) { lcv.width = target.width; lcv.height = target.height; }
      return lcv;
    }
    function getImage(src) {
      if (!images[src]) {
        var img = new Image();
        /* imágenes de diseños guardados (Cloudinary, CORS *): sin esto el lienzo queda «tainted» y no se exporta */
        if (/^https?:/i.test(src)) img.crossOrigin = 'anonymous';
        img.onload = requestRender;
        img.src = src;
        images[src] = img;
      }
      return images[src];
    }
    /* Capas compuestas en un lienzo auxiliar del tamaño del destino, colocadas con frame.fwd. Vista previa y JPG: marco
       de foto curvado al cuerpo y recortado con la silueta. Editor (noMask): camiseta plana, sin recorte, así el diseño
       se ve siempre entero y a tamaño real. */
    function drawWarped(c, target, layers, area, frame, kind, tf, k, key, noMask) {
      if (!layers.some(function (l) { return !l.hidden; })) return;
      flatCache[key] = flatCache[key] || {};
      var flat = G.renderFlat(layers, area, frame, k, getImage, flatCache[key]);
      flatCache[key].canvas = flat.canvas;
      var lcv = layerCanvasFor(key, target), lc = lcv.getContext('2d');
      lc.setTransform(1, 0, 0, 1, 0, 0);
      lc.clearRect(0, 0, lcv.width, lcv.height);
      lc.setTransform.apply(lc, tf);
      G.warpBlit(lc, flat, frame, 0.6 / tf[0]);
      if (!noMask) maskWith(lc, frame, kind);
      c.save();
      c.setTransform(1, 0, 0, 1, 0, 0);
      c.drawImage(lcv, 0, 0);
      c.restore();
    }
    /* Medidas con las que se dibuja la silueta: al cambiar de talla pasan de la anterior a la nueva en GARMENT_ANIM_MS
       (solo el dibujo de la prenda; los diseños, límites y cálculos usan siempre la talla elegida). */
    function lerpMed(a, b, t) {
      return Object.keys(b).reduce(function (acc, k) {
        acc[k] = typeof a[k] === 'number' && typeof b[k] === 'number' ? a[k] + (b[k] - a[k]) * t : b[k];
        return acc;
      }, {});
    }
    function garmentMed() {
      var target = med(), now = performance.now();
      if (!shownMed || reducedMotion) { shownMed = target; garmentAnim = null; return target; }
      if (garmentAnim && garmentAnim.to !== target) garmentAnim = { from: garmentAnim.cur, to: target, t0: now, cur: garmentAnim.cur };
      if (!garmentAnim && shownMed !== target) garmentAnim = { from: shownMed, to: target, t0: now, cur: shownMed };
      if (!garmentAnim) return target;
      var t = Math.min(1, (now - garmentAnim.t0) / GARMENT_ANIM_MS);
      if (t >= 1) { garmentAnim = null; shownMed = target; return target; }
      garmentAnim.cur = lerpMed(garmentAnim.from, target, 1 - Math.pow(1 - t, 3));
      if (!animRaf) animRaf = requestAnimationFrame(function () { animRaf = 0; renderEditor(); });
      return garmentAnim.cur;
    }
    function renderEditor() {
      var def = vdef(), frame = state.size ? GM.editorFrame(def.id, state.size, garmentMed()) : null, stage = q('[data-cte-stage]');
      metrics = null;
      if (!frame) { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height); placeOverlay(); return; }
      var maxH = window.innerWidth <= 900 ? 460 : 720, aspect = frame.view.h / frame.view.w;
      var cssW = Math.max(200, stage.clientWidth), cssH = cssW * aspect;
      if (cssH > maxH) { cssH = maxH; cssW = cssH / aspect; }
      var dpr = sizeCanvas(canvas, Math.round(cssW), Math.round(cssH)), s = Math.round(cssW) / frame.view.w, px = 1 / s;
      var tf = [dpr * s, 0, 0, dpr * s, -frame.view.x * dpr * s, -frame.view.y * dpr * s];
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.setTransform.apply(ctx, tf);
      GM.drawEditorBase(ctx, frame);
      if (showMeasures && !dragging) GM.drawMeasures(ctx, frame, px, uiFont);
      var ep = editPrint(), area = areaOf(state.tab, ep);
      metrics = { frame: frame, s: s, tf: tf, kind: def.kind, cmPerPx: 1 / (frame.pxPerCm * s), items: [{ print: ep, area: area, cv: G.areaCenterV(area) }], cota: null };
      drawWarped(ctx, canvas, ep.layers, renderArea(state.tab, ep), frame, def.kind, tf, frame.pxPerCm * s * dpr, 'ed-' + state.tab, true);
      if (def.kind === 'back') GM.drawEditorHood(ctx, frame, hoodAlpha());
      if (dragging) usefulArea(ctx, frame, area, px);
      var group = activeGroup(), rows = refRows(state.tab);
      if (def.kind === 'sleeve') {
        if (group) {
          D.printOutline(ctx, frame, area, px, { active: true, noLabel: true, warn: rowIssue(rows, group.id) });
          metrics.cota = D.hemCota(ctx, frame, area, px, uiFont, ep.dist, true);
        }
      } else {
        prints().forEach(function (p) {
          D.printOutline(ctx, frame, designRect(state.tab, p), px, { active: p === group, noLabel: true, warn: rowIssue(rows, p.id), empty: false });
        });
        if (group) {
          var r = designRect(state.tab, group);
          metrics.cota = D.neckCota(ctx, frame, r, px, uiFont, true);
          D.centerAxis(ctx, frame, px);
        }
      }
      var l = selected(), m = { cu: area.cu, cv: metrics.items[0].cv, cmPerPx: metrics.cmPerPx };
      selectedIds().forEach(function (id) {
        var x = itemsOf().filter(function (y) { return y.id === id; })[0];
        if (x && x !== l && !x.hidden) D.layerOutline(ctx, frame, x, px, m);
      });
      if (l && !l.hidden) D.selection(ctx, frame, l, px, m);
      placeOverlay();
    }
    /* Límite útil (moveLimits) en punteado fino: solo mientras se arrastra o se escala. area: la de editPrint. */
    function usefulArea(c, frame, area, px) {
      var lim = moveLimits(), cv = G.areaCenterV(area);
      if (![lim.x0, lim.x1, lim.y0, lim.y1].every(isFinite)) return;
      D.freeArea(c, frame, { cu: area.cu + (lim.x0 + lim.x1) / 2, w: lim.x1 - lim.x0, top: cv + lim.y0, h: lim.y1 - lim.y0 }, px);
    }
    function itemOf(p) { return p && metrics ? metrics.items.filter(function (it) { return it.print.id === p.id; })[0] || null : null; }
    function refRows(viewId) {
      var row = ((state.medidasPorTalla || {})[viewId] || []).filter(function (r) { return r.ref; })[0];
      return row ? row.impresiones : [];
    }
    function rowIssue(rows, id) {
      var r = rows.filter(function (x) { return x.id === id; })[0];
      return !!(r && (r.excede || r.fueraPrenda || r.pasaHombro));
    }

    /* ---------- controles sobre la prenda: barra flotante y cota editable ---------- */
    var floatEl = q('[data-cte-float]'), cotaBtn = q('[data-cte-cota]'), cotaEdit = q('[data-cte-cota-edit]'), cotaInput = q('[data-cte-cota-input]'), cotaHelp = q('[data-cte-cota-help]');
    var floatZone = '', SU = null;
    function cotaValue() {
      var g = activeGroup();
      if (!g) return null;
      return isFlat(state.tab) ? M.round1(designRect(state.tab, g).top) : g.dist;
    }
    function placeOverlay() {
      var stage = q('[data-cte-stage]'), l = selected(), locked = !!lockReason();
      if (floatZone !== state.tab) { floatEl.innerHTML = OV.toolbar(vdef()); floatZone = state.tab; }
      var editing = !cotaEdit.hidden, value = cotaValue(), avoid = null;
      cotaBtn.hidden = !metrics || !metrics.cota || locked || editing || value == null;
      if (!metrics || !metrics.cota) cotaEdit.hidden = true;
      else {
        var pt = OV.toCss(metrics, canvas, metrics.cota.x, metrics.cota.y);
        if (!cotaBtn.hidden) {
          var label = fmt(value) + ' cm';
          cotaBtn.textContent = label + ' ✎';
          cotaBtn.setAttribute('aria-label', vdef().refLabel + ': ' + label + '. Pulsa para cambiarla.');
          cotaBtn.title = vdef().refLabel;
          avoid = OV.placeCota(cotaBtn, pt);
        }
        if (editing) { avoid = OV.placeCota(cotaEdit, pt); placeCotaHelp(); }
      }
      var wl = SU && SU.place(stage); /* la barra no tapa la cota, el ancho ni el asa de giro */
      floatEl.hidden = !metrics || !l || locked || dragging;
      if (floatEl.hidden) return;
      var cm = metrics.items[0], pts = G.layerCorners(l).map(function (c) {
        var p = metrics.frame.fwd(c.x + cm.area.cu, c.y + cm.cv);
        return OV.toCss(metrics, canvas, p.x, p.y);
      });
      var box = GR.boxOf(pts), rh = D.rotHandle(l, metrics.cmPerPx), rp = metrics.frame.fwd(rh.x + cm.area.cu, rh.y + cm.cv);
      var rc = OV.toCss(metrics, canvas, rp.x, rp.y), rot = { x0: rc.x - 22, x1: rc.x + 22, y0: rc.y - 22, y1: rc.y + 22 }; /* asa de giro */
      var mini = q('[data-cte-fotomini]'), mr = mini && mini.offsetWidth ? { x0: mini.offsetLeft - 4, x1: mini.offsetLeft + mini.offsetWidth + 4, y0: mini.offsetTop - 4, y1: mini.offsetTop + mini.offsetHeight + 4 } : null;
      OV.placeFloat(floatEl, stage, box, [avoid, wl, rot, mr]); /* la barra no tapa la miniatura «Foto real» */
      /* caja del elemento en px del escenario (la usan las pruebas automáticas para arrastrar) */
      floatEl.dataset.box = [box.x0, box.y0, box.x1, box.y1].map(Math.round).join(',');
    }
    /* Ayuda de la distancia (detrás de la sudadera con capucha), justo debajo del campo y dentro del escenario. */
    function placeCotaHelp() {
      if (cotaHelp.hidden) return;
      var stage = q('[data-cte-stage]'), left = Math.min(cotaEdit.offsetLeft, Math.max(0, stage.clientWidth - cotaHelp.offsetWidth - 4));
      cotaHelp.style.left = Math.max(4, left) + 'px';
      cotaHelp.style.top = (cotaEdit.offsetTop + cotaEdit.offsetHeight + 4) + 'px';
    }
    function openCota() {
      var value = cotaValue();
      if (value == null) return;
      cotaEdit.hidden = false;
      cotaBtn.hidden = true;
      cotaInput.value = fmt(value);
      cotaInput.placeholder = vdef().kind === 'sleeve' ? '' : String(vdef().defaultDist);
      cotaInput.setAttribute('aria-label', vdef().refLabel + ' (cm)' + (vdef().help ? '. ' + vdef().help : ''));
      cotaHelp.textContent = vdef().help || '';
      cotaHelp.hidden = !vdef().help;
      placeOverlay();
      cotaInput.focus();
      cotaInput.select();
    }
    function posMsg(text) {
      var msg = q('[data-cte-pos-msg]');
      msg.hidden = !text;
      msg.textContent = text;
    }
    /* Confirma la distancia escrita; vacía o fuera de rango no se acepta (es obligatoria). */
    function commitCota() {
      var parsed = IO.parseCm(cotaInput.value, 0, DIST_MAX);
      if (parsed.empty) { posMsg(vdef().refLabel + ' es obligatoria.'); cotaInput.setAttribute('aria-invalid', 'true'); return false; }
      if (parsed.invalid) { posMsg('La distancia debe estar entre 0 y ' + DIST_MAX + ' cm.'); cotaInput.setAttribute('aria-invalid', 'true'); return false; }
      cotaInput.setAttribute('aria-invalid', 'false');
      posMsg('');
      closeCota();
      setDistance(parsed.value);
      return true;
    }
    function closeCota(keepMsg) { cotaEdit.hidden = true; cotaHelp.hidden = true; if (!keepMsg) posMsg(''); placeOverlay(); }
    function setDistance(value) {
      var g = activeGroup();
      if (!g) return;
      if (!isFlat(state.tab)) {
        /* sudaderas: la impresión de manga no pisa el canalé del puño */
        var min = vdef().minDist || 0;
        if (value < min) posMsg('La manga lleva un puño de canalé de ' + fmt(min) + ' cm: el diseño empieza encima.');
        return setState({ views: withView(state.tab, { dist: Math.max(value, min) }) });
      }
      if (value < M.NECK_MARGIN_CM) posMsg('A menos de ' + fmt(M.NECK_MARGIN_CM) + ' cm del cuello está el ribete y no se imprime: el diseño empieza a ' + fmt(M.NECK_MARGIN_CM) + ' cm.');
      if (shiftGroupLimited(g, 0, value - designRect(state.tab, g).top) && value >= M.NECK_MARGIN_CM) posMsg(LIMIT_MSG);
    }
    /* Mueve el diseño con tope (moveLimits). Devuelve true si ha hecho tope. */
    var LIMIT_MSG = 'Se ha ajustado para que el diseño no pase del límite útil de la prenda.';
    function shiftGroupLimited(g, du, dv) {
      var r = designRect(state.tab, g);
      var s = A.clampShift({ x0: r.cu - r.w / 2 + du, x1: r.cu + r.w / 2 + du, y0: r.top + dv, y1: r.top + r.h + dv }, moveLimits());
      shiftGroup(g, du + s.dx, dv + s.dy);
      return Math.abs(s.dx) > 0.001 || Math.abs(s.dy) > 0.001;
    }
    function shiftGroup(g, du, dv) {
      var all = {};
      g.itemIds.forEach(function (id) { all[id] = { dx: du, dy: dv }; });
      shiftLayers(all);
    }

    /* Alinear en la prenda el diseño del elemento seleccionado (su impresión entera) o borrar el elemento. */
    function applyOp(op) {
      var g = activeGroup();
      if (op === 'borrar') return state.sel && removeLayer(state.sel);
      if (!g) return;
      if (!isFlat(state.tab)) {
        var b = G.designBounds(g.layers);
        if (!b) return;
        var sh = A.sleeveShift(op, b, areaOf(state.tab, g)), all = {};
        g.layers.forEach(function (l) { all[l.id] = sh; });
        shiftLayers(all);
      } else {
        var r = designRect(state.tab, g), lim = garmentLimitsBySize(vdef().kind)[state.size] || {};
        var halfW = M.usefulHalfWidth(vdef().kind, med());
        if (halfW == null && (op === 'borde-izq' || op === 'borde-der')) return announce('No se conoce el ancho de esta prenda: no se puede alinear al costado.');
        var t = A.printTarget(op, r, { hemV: lim.length, halfW: halfW, zone: GM.zoned ? moveLimits() : null, topDist: vdef().defaultDist });
        shiftGroup(g, t.cu - r.cu, t.top - r.top);
      }
      var label = (q('[data-cte-op="' + op + '"]') || {}).title || '';
      announce(label ? 'Hecho: ' + label.toLowerCase() + '.' : '');
    }

    /* Vista previa: delante (con las mangas) y detrás. */
    /* Vista previa con la foto: el lienzo de la columna lateral (lo copia también la revisión del pedido) y, si está
       abierta, la hoja móvil «Ver cómo queda puesta». */
    function renderPreviews() {
      /* con la silueta plana se rotula «Simulación sobre silueta» y la foto real del color va justo debajo */
      if (FOTOS) {
        var f0 = frameFor(viewsOfKind('front')[0].id, state.size);
        FOTOS.sync(state.color, f0 ? !!f0.previewFlat : false);
      }
      ['front', 'back'].forEach(function (kind) {
        var targets = [q('[data-cte-prev="' + kind + '"]')].concat(sheet.hidden ? [] : [q('[data-cte-prev-sheet="' + kind + '"]')]);
        targets.forEach(function (cv, i) { renderPreview(kind, cv, i ? '-sheet' : ''); });
      });
      root.dispatchEvent(new CustomEvent('cte:previews'));
    }
    function renderPreview(kind, cv, keySuffix) {
      var views = viewsOfKind(kind), viewId = views[0].id;
      var pc = cv.getContext('2d'), frame = frameFor(viewId, state.size);
      if (!frame) { pc.setTransform(1, 0, 0, 1, 0, 0); pc.clearRect(0, 0, cv.width, cv.height); return; }
      var cssW = cv.parentNode.clientWidth || 140, cssH = Math.round(cssW * frame.view.h / frame.view.w);
      var dpr = sizeCanvas(cv, cssW, cssH), s = cssW / frame.view.w;
      var tf = [dpr * s, 0, 0, dpr * s, -frame.view.x * dpr * s, -frame.view.y * dpr * s];
      pc.setTransform(1, 0, 0, 1, 0, 0);
      pc.clearRect(0, 0, cv.width, cv.height);
      pc.setTransform.apply(pc, tf);
      drawBase(pc, frame, kind);
      if (!state.size) return;
      views.forEach(function (v) {
        prints(v.id).forEach(function (p) {
          drawWarped(pc, cv, p.layers, renderArea(v.id, p), frame, kind, tf, frame.pxPerCm * s * dpr * 1.5, 'pv-' + p.id + keySuffix);
        });
      });
      if (kind === 'front') drawSleevesOnFront(pc, cv, frame, tf, keySuffix);
    }
    /* Las mangas se ven casi de canto desde delante: se colocan sobre la manga de la foto, comprimidas en horizontal. */
    function drawSleevesOnFront(pc, cv, frame, tf, keySuffix) {
      VIEWS.filter(function (v) { return v.kind === 'sleeve'; }).forEach(function (v) {
        var p = prints(v.id)[0];
        if (!p || !p.layers.some(function (l) { return !l.hidden; })) return;
        var area = areaOf(v.id, p), key = 'pv-' + v.id + (keySuffix || '');
        flatCache[key] = flatCache[key] || {};
        var flat = G.renderFlat(p.layers, area, frameFor(v.id, state.size), frame.pxPerCm * tf[0] * 1.5, getImage, flatCache[key]);
        flatCache[key].canvas = flat.canvas;
        /* manga izquierda del que la lleva = derecha en la foto */
        var at = GM.sleeveAnchor(frame, v.side, cal);
        var cmPx = frame.pxPerCm / flat.k, lcv = layerCanvasFor(key, cv), lc = lcv.getContext('2d');
        lc.setTransform(1, 0, 0, 1, 0, 0);
        lc.clearRect(0, 0, cv.width, cv.height);
        lc.setTransform.apply(lc, tf);
        lc.translate(at.x, at.y);
        lc.rotate(G.rad(at.deg));
        lc.scale(cmPx * SLEEVE_FORESHORTEN, cmPx);
        lc.drawImage(flat.canvas, flat.u0 * flat.k, (flat.v0 - G.areaCenterV(area)) * flat.k);
        lc.setTransform.apply(lc, tf);
        maskWith(lc, frame, 'front');
        pc.save();
        pc.setTransform(1, 0, 0, 1, 0, 0);
        pc.drawImage(lcv, 0, 0);
        pc.restore();
      });
    }

    /* ---------- datos derivados que se guardan en el diseño (pedido y carrito) ---------- */
    function storeDerived() {
      var table = {}, list = [];
      activeViews().forEach(function (v) {
        var ps = prints(v.id);
        if (state.size) {
          table[v.id] = M.scalingTable({
            sizes: productSizes, ref: state.size, kind: v.kind, medidas: data.medidas,
            limits: limitsBySize(v.id),
            prints: ps.map(function (p) {
              var r = designRect(v.id, p);
              return { id: p.id, nombre: printName(v.id, p), dist: v.kind === 'sleeve' ? p.dist : r.top, dx: r.cu, bounds: G.designBounds(p.layers) };
            })
          });
        }
        var bill = ((table[v.id] || []).filter(function (r) { return r.talla === billingTalla(); })[0] || { impresiones: [] }).impresiones;
        ps.forEach(function (p) {
          var r = designRect(v.id, p), b = bill.filter(function (x) { return x.id === p.id; })[0] || {};
          /* distancia: del cuello al borde superior del diseño (delante/detrás) o del bajo de la manga (mangas).
             tamano: tamaño de cobro en la talla de cobro (null sin capas o si supera el máximo). */
          list.push({
            id: p.id, vista: v.id, nombre: printName(v.id, p), tamano: b.tamano || null, excede: !!b.excede, ajuste: b.ajuste || null,
            tallaCobro: billingTalla() || null, ancho: b.ancho == null ? null : b.ancho, alto: b.alto == null ? null : b.alto,
            distancia: v.kind === 'sleeve' ? p.dist : M.round1(r.top), referencia: v.kind === 'sleeve' ? 'bajo_manga' : 'cuello',
            desplazamiento: v.kind === 'sleeve' ? 0 : M.round1(r.cu), capas: p.layers.length
          });
        });
      });
      state = Object.assign({}, state, { tallaReferencia: state.size, medidasPorTalla: table, impresiones: list, impresionesPorTamano: M.countBySize(list) });
    }

    /* ---------- controles ---------- */
    function syncZones() {
      q('[data-cte-zones]').innerHTML = UI.zones(VIEWS.map(function (v) {
        return { id: v.id, label: v.label, count: itemsOf(v.id).length };
      }), state.tab);
    }
    function sizesWhere(rows, id, key) {
      return rows.filter(function (r) { return r.impresiones.some(function (x) { return x.id === id && x[key]; }); }).map(function (r) { return r.talla; });
    }
    function tallas(list) { return (list.length === 1 ? 'la talla ' : 'las tallas ') + list.join(', '); }
    /* Qué limita la zona útil de la vista actual (sudaderas), para el aviso. */
    function zoneObstacles() {
      var st = prendaTpl ? prendaTpl.SHAPE : {}, k = vdef().kind, out = ['el canalé de la cintura'];
      if (k === 'front' && st.POCKET) out.unshift('el bolsillo');
      if (k === 'front' && st.ZIP) out.unshift('la cremallera');
      return out.length > 1 ? out.slice(0, -1).join(', ') + ' o ' + out[out.length - 1] : out[0];
    }
    /* Detrás de la sudadera con capucha: cm (enteros) que tapa la capucha bajada de la parte de arriba del diseño en la
       talla de referencia; 0 si no lo toca. Informa, no bloquea. */
    function hoodCoverCm(p) {
      if (!GM.hasHood || vdef().kind !== 'back') return 0;
      var r = designRect(state.tab, p);
      if (r.empty) return 0;
      var cm = GM.hoodCover(state.size, { x0: r.cu - r.w / 2, x1: r.cu + r.w / 2, y0: r.top, y1: r.top + r.h });
      return cm >= 0.5 ? Math.round(cm) : 0;
    }
    /* Píxeles por pulgada de una imagen a su ancho actual (talla de referencia). */
    function effectiveDpi(l) { return l.nw / (l.w / 2.54); }
    /* Avisos cortos: solo lo que impide pedir o sale mal en producción. */
    function syncWarn() {
      var warn = [], info = [], def = vdef();
      if (state.size && !lockReason()) {
        var rows = (state.medidasPorTalla || {})[state.tab] || [];
        prints().forEach(function (p) {
          var name = shownName(state.tab, printName(state.tab, p));
          var over = sizesWhere(rows, p.id, 'excede');
          if (over.length) warn.push(name + ' supera ' + (def.kind === 'sleeve' ? '10×10' : '40×50') + ' en ' + tallas(over) + ': redúcelo para poder pedir.');
          if (def.kind === 'sleeve') {
            var a = areaOf(state.tab, p), out = p.layers.filter(function (l) { return !l.hidden && G.isOutside(l, a); });
            if (out.length) warn.push('Parte del diseño se sale de la zona de 10×10 de la manga y no se imprimirá.');
            var high = sizesWhere(rows, p.id, 'pasaHombro');
            if (high.length) warn.push(name + ' pasa la costura del hombro en ' + tallas(high) + '.');
          } else {
            var off = sizesWhere(rows, p.id, 'fueraPrenda');
            if (off.length) warn.push(name + ' se sale de la prenda en ' + tallas(off) + '.');
            var zona = sizesWhere(rows, p.id, 'fueraZona');
            if (zona.length) warn.push(name + ' pisa ' + zoneObstacles() + ' en ' + tallas(zona) + '.');
            var hood = hoodCoverCm(p);
            if (hood) info.push((prints().length > 1 ? name + ': l' : 'L') + 'a capucha tapará unos ' + hood + ' cm de la parte superior del diseño cuando esté bajada.');
            var useful = sizesWhere(rows, p.id, 'fueraAnchoUtil');
            if (useful.length) info.push(name + ' queda muy cerca del costado en ' + tallas(useful) + '.');
          }
        });
      }
      var low = itemsOf().filter(function (l) { return l.type === 'image' && !l.hidden && effectiveDpi(l) < MIN_DPI; });
      if (low.length) info.push('Resolución baja para este tamaño: ' + low.map(function (l) { return '«' + l.name + '» (' + Math.round(effectiveDpi(l)) + ' ppp)'; }).join(', ') + '. Se recomiendan ' + MIN_DPI + ' ppp o más.');
      var w = q('[data-cte-warn]'), n = q('[data-cte-info]');
      w.hidden = !warn.length; w.textContent = warn.join(' ');
      n.hidden = !info.length; n.textContent = info.join(' ');
    }
    /* «Más opciones»: capas y orden, desplazamiento horizontal y alinear/distribuir capas entre sí. */
    function layerName(l) { return l.type === 'text' ? (l.text || 'Texto') : l.name; }
    var listKey = '';
    function renderLayers() {
      var p = activePrint(), items = itemsOf().slice().reverse(), area = p && areaOf(state.tab, p), ids = selectedIds();
      q('[data-cte-layers-count]').textContent = String(items.length);
      q('[data-cte-layers-empty]').hidden = items.length > 0;
      var rows = items.map(function (l) {
        return { layer: l, name: layerName(l), selected: ids.indexOf(l.id) !== -1, outside: !isFlat(state.tab) && !l.hidden && G.isOutside(l, area) };
      });
      var key = state.tab + '|' + rows.map(function (r) { return [r.layer.id, r.name, r.layer.hidden, r.outside, r.selected].join(':'); }).join(',');
      if (key === listKey) return;
      listKey = key;
      q('[data-cte-layers]').innerHTML = UI.layers(rows);
    }
    function syncMore() {
      var n = selectedIds().length, g = activeGroup(), flat = isFlat(state.tab);
      qa('[data-cte-lalign]').forEach(function (b) { b.disabled = n < 1; });
      qa('[data-cte-ldist]').forEach(function (b) { b.disabled = n < 3; });
      q('[data-cte-layer-align]').hidden = !itemsOf().length;
      var field = q('[data-cte-dx-field]'), dx = q('[data-cte-dx]');
      field.hidden = !flat || !g;
      if (!field.hidden && document.activeElement !== dx) dx.value = fmt(designRect(state.tab, g).cu);
      q('[data-cte-pecho-field]').hidden = !flat || !g || !vdef().pecho;
    }
    function renderScale() {
      var def = vdef();
      var rows = (state.medidasPorTalla || {})[state.tab] || [];
      var hasRows = rows.length && rows[0].impresiones.some(function (p) { return p.ancho != null; });
      q('[data-cte-scale-ref]').textContent = def.label + ' · referencia: talla ' + (state.size || '—') + ' · ±' + fmt(M.SCALE_STEP * 100) + ' % por talla · ancho en cm enteros';
      q('[data-cte-scale-dist-h]').textContent = def.refLabel;
      q('[data-cte-scale-empty]').hidden = !!hasRows;
      q('[data-cte-scale-wrap]').hidden = !hasRows;
      q('[data-cte-scale-body]').innerHTML = hasRows ? UI.scaleRows(rows, {
        sleeve: def.kind === 'sleeve', billing: billingTalla(), distLabel: def.refLabel, name: function (p) { return shownName(state.tab, p.nombre); }
      }) : '';
    }
    function syncLock() {
      var reason = lockReason();
      q('[data-cte-lock]').hidden = !reason;
      q('[data-cte-lock-msg]').textContent = reason;
      canvas.classList.toggle('is-locked', !!reason);
      var soloTalla = reason === MSG_TALLA && esMovil();
      qa('[data-cte-add-image], [data-cte-add-text]').forEach(function (b) { b.disabled = !!reason && !soloTalla; b.classList.toggle('is-soft', soloTalla); });
      if (!reason) { q('[data-cte-need-size]').hidden = true; q('.cte-block--sizes').classList.remove('is-flash'); }
      q('[data-cte-measures-wrap]').hidden = !!reason; /* tras elegir talla */
      syncHood(reason);
    }
    /* Botón «Ver capucha» (solo detrás de las sudaderas con capucha): 50 % → 100 % → oculta → 50 %. */
    var HOOD_LABEL = { media: '50 %', entera: '100 %', oculta: 'oculta' };
    function syncHood(reason) {
      var b = q('[data-cte-hood]');
      b.hidden = !GM.hasHood || vdef().kind !== 'back' || !!(reason === undefined ? lockReason() : reason);
      b.classList.toggle('is-off', hoodMode === 'oculta');
      b.setAttribute('aria-label', 'Ver capucha: ' + HOOD_LABEL[hoodMode] + '. Pulsa para cambiar.');
      q('[data-cte-hood-state]').textContent = HOOD_LABEL[hoodMode];
    }
    function syncOptions() {
      q('[data-cte-colors]').innerHTML = UI.colors(data.colors, state.color);
      var ofColor = (data.variants || []).filter(function (v) { return v.color === state.color; });
      q('[data-cte-sizes]').innerHTML = UI.sizes(ofColor, state.size, data.medidas);
      var cur = ofColor.filter(function (v) { return v.talla === state.size; })[0], msg = q('[data-cte-size-msg]');
      msg.hidden = !(cur && !cur.available);
      msg.textContent = cur && !cur.available ? 'La talla ' + state.size + ' no tiene stock en ' + state.color + '.' : '';
      q('[data-cte-color-name]').textContent = state.color;
      plegarColores();
    }
    var text = null;
    function update() {
      GM.ensure(state.color);
      if (!VIEW[state.tab]) state = Object.assign({}, state, { tab: VIEWS[0].id, sel: null, selIds: [] });
      if (state.sel && !selected()) state = Object.assign({}, state, { sel: null, selIds: [] });
      syncOptions();
      syncZones();
      storeDerived();
      renderEditor();
      renderLayers();
      syncMore();
      syncWarn();
      syncLock();
      renderScale();
      if (text) text.sync();
      renderPreviews();
      root.dispatchEvent(new CustomEvent('cte:change'));
    }
    function updateLight() {
      storeDerived();
      requestRender();
      syncWarn();
      renderScale();
      renderLayers();
      syncMore();
      if (text) text.sync();
      root.dispatchEvent(new CustomEvent('cte:change'));
    }
    function fontLoaded() { fontsVersion++; listKey = ''; update(); }

    /* ---------- elementos ---------- */
    /* Caja para dimensionar elementos nuevos: la típica de la zona (delante/detrás) o la impresión (mangas). */
    function newLayerBox() {
      if (isFlat(state.tab)) return M.printSize(DEFAULT_BOX[vdef().kind] || '10x10');
      var a = areaOf(state.tab, editPrint());
      return { w: a.w, h: a.h };
    }
    /* Posición de un elemento nuevo. Delante/detrás: sin diseño, centrado con el borde superior a la distancia
       habitual (8 cm del cuello); con diseño, centrado bajo él y a menos de 2 cm (se imprime con él). Mangas: sin
       diseño, apoyado abajo (a la distancia del bajo); con diseño, en su centro. */
    function placeNewLayer(layer) {
      var s = G.layerSize(layer), def = vdef(), vis = itemsOf().filter(function (l) { return !l.hidden; });
      if (!isFlat(state.tab)) {
        var b = G.designBounds(vis), a = areaOf(state.tab, editPrint());
        if (b && b.w > 0) return Object.assign({}, layer, { x: round(b.cx, 2), y: round(b.cy, 2) });
        return Object.assign({}, layer, { x: 0, y: round(a.h / 2 - s.h / 2, 2) });
      }
      if (!vis.length) {
        /* a la distancia habitual del cuello; si desde ahí no cabe hasta el bajo útil, más arriba (como mucho hasta el
           mínimo: NECK_MARGIN_CM o el de la zona). Lo que siga sin caber lo reduce addImageLayer. */
        var z = moveLimits(), top = Math.max(def.defaultDist, z.y0);
        if (s.h > z.y1 - top) top = Math.max(z.y0, z.y1 - s.h);
        return Object.assign({}, layer, { x: GM.zoned ? round((z.x0 + z.x1) / 2, 2) : 0, y: round(top + s.h / 2, 2) });
      }
      var u = GR.union(vis.map(function (l) { return GR.boxOf(G.layerCorners(l)); }));
      return Object.assign({}, layer, { x: round((u.x0 + u.x1) / 2, 2), y: round(u.y1 + NEW_GAP_CM + s.h / 2, 2) });
    }
    function addLayer(raw) {
      var layer = placeNewLayer(raw);
      setItems(itemsOf().concat([layer]), { sel: layer.id, selIds: [layer.id] });
      announce((layer.type === 'text' ? 'Texto añadido' : 'Imagen añadida') + ' en ' + vdef().label + '. Arrástralo para colocarlo.');
    }
    function addImageLayer(name, res) {
      var a = newLayerBox(), nw = res.img.naturalWidth, nh = res.img.naturalHeight;
      var max = isFlat(state.tab) ? free : a;
      var fit = Math.min(a.w, a.h * nw / nh) * NEW_LAYER_FILL;
      var w = res.physW && res.physW <= max.w && res.physW * nh / nw <= max.h ? res.physW : fit;
      images[res.src] = res.img;
      addLayer({ id: IO.uid(), type: 'image', name: name, src: res.src, thumb: IO.thumbOf(res.img), nw: nw, nh: nh, w: round(w, 2), x: 0, y: 0, rotation: 0, hidden: false });
      if (isFlat(state.tab) && SU) SU.fitSelection();
    }
    function contrastInk() { return G.isLight(garmentColor()) ? '#141414' : '#FFFFFF'; }
    function addTextLayer() {
      var a = newLayerBox(), f = F.get(F.DEFAULT_KEY);
      addLayer({
        id: IO.uid(), type: 'text', text: 'TU TEXTO', fontKey: f.key, family: f.family, weight: f.weight,
        color: contrastInk(), size: round(Math.min(a.h * 0.18, a.w / 5, 6), 1), x: 0, y: 0, rotation: 0, hidden: false
      });
      F.ensure(f.key, 'TU TEXTO').then(fontLoaded, function (err) { announce(err.message); });
      var t = q('[data-cte-text]');
      if (t) { t.focus(); t.select(); }
    }
    function layerBox(l) { return Object.assign({ id: l.id }, A.boxOf(G.layerCorners(l))); }
    /* Alinear capas entre sí: respecto a la selección (2 o más) o al diseño de la zona (1). */
    function alignLayers(op) {
      var ids = selectedIds();
      if (!ids.length) return;
      var boxes = itemsOf().filter(function (l) { return ids.indexOf(l.id) !== -1; }).map(layerBox);
      /* una sola capa: respecto a su diseño (la impresión en la que está), en cm de la zona */
      var g = activeGroup(), inDesign = function (l) { return !l.hidden && (!g || !g.itemIds || g.itemIds.indexOf(l.id) !== -1); };
      var ref = A.union(ids.length >= 2 ? boxes : itemsOf().filter(inDesign).map(layerBox));
      shiftLayers(A.alignLayers(op, boxes, ref));
    }
    function distributeLayers(axis) {
      var ids = selectedIds();
      if (ids.length < 3) return;
      shiftLayers(A.distribute(axis, itemsOf().filter(function (l) { return ids.indexOf(l.id) !== -1; }).map(layerBox)));
    }
    function removeLayer(id) {
      setItems(itemsOf().filter(function (l) { return l.id !== id; }), { sel: state.sel === id ? null : state.sel, selIds: (state.selIds || []).filter(function (x) { return x !== id; }) });
      announce('Elemento borrado.');
    }
    /* Mueve una capa a la posición de lista indicada (0 = arriba = delante). */
    function moveLayerTo(id, listIndex) {
      var list = itemsOf().slice().reverse();
      var item = list.filter(function (l) { return l.id === id; })[0];
      if (!item) return;
      var rest = list.filter(function (l) { return l.id !== id; }), to = G.clamp(listIndex, 0, rest.length);
      setItems(rest.slice(0, to).concat([item], rest.slice(to)).reverse());
    }
    function readFile(file) {
      if (!file) return;
      announce('Leyendo ' + file.name + '…');
      (IO.isPdf(file) ? IO.readPdfFile(file) : IO.readImageFile(file)).then(function (res) {
        if (lockReason()) throw IO.userError('El editor aún no está listo: espera a que cargue la prenda.');
        addImageLayer(file.name, res);
      }).catch(function (err) {
        var msg = err && err.userFacing ? err.message : 'No se ha podido añadir la imagen.';
        announce(msg);
        q('[data-cte-warn]').hidden = false;
        q('[data-cte-warn]').textContent = msg;
      });
    }
    /* Escalar por las esquinas o pellizcando (base = la capa al empezar): sin deformar, con ancla y tope (size-ui). */
    function scaleFrom(base, factor) {
      return base.type === 'text' ? SU.scaleFrom(base, factor, TEXT_MIN, TEXT_MAX) : SU.scaleFrom(base, factor, IMAGE_W_MIN, IMAGE_W_MAX);
    }

    /* ---------- eventos ---------- */
    root.addEventListener('click', function (e) {
      var t = e.target, el;
      if (t.closest('[data-cte-morecolors]')) {
        coloresAbiertos = !coloresAbiertos;
        plegarColores();
        /* al replegar, la zona de colores vuelve a la vista (si no, la página queda mucho más abajo) */
        if (!coloresAbiertos) {
          var blk = q('.cte-block--colors'), cab = altoCabecera(), y = blk.getBoundingClientRect().top;
          if (y < cab) window.scrollTo({ top: Math.max(0, window.scrollY + y - cab - 12), behavior: 'instant' });
        }
        return;
      }
      if (!state.size && esMovil() && t.closest('[data-cte-add-image], [data-cte-add-text], [data-cte-lock]')) return pedirTalla();
      if ((el = t.closest('[data-cte-color]'))) return setState({ color: el.dataset.cteColor });
      if ((el = t.closest('[data-cte-size]')) && !el.disabled) return setState({ size: el.dataset.cteSize });
      if ((el = t.closest('[data-cte-tab]'))) return setState({ tab: el.dataset.cteTab, printId: null, sel: null, selIds: [] });
      if ((el = t.closest('[data-cte-op]'))) return applyOp(el.dataset.cteOp);
      if ((el = t.closest('[data-cte-sheet-open]'))) return openSheet(el);
      if (t.closest('[data-cte-sheet-close]') || t === sheet) return closeSheet();
      if (t.closest('[data-cte-cota]')) return openCota();
      if (t.closest('[data-cte-add-image]')) return q('[data-cte-file]').click();
      if (t.closest('[data-cte-add-text]')) return addTextLayer();
      if ((el = t.closest('[data-cte-lalign]')) && !el.disabled) return alignLayers(el.dataset.cteLalign);
      if ((el = t.closest('[data-cte-ldist]')) && !el.disabled) return distributeLayers(el.dataset.cteLdist);
      var li = t.closest('.cte-layer');
      if (li && t.closest('[data-cte-pick]')) return isMulti(e) ? toggleSel(activePrint().id, li.dataset.id) : selectOnly(activePrint().id, li.dataset.id);
      if (li && t.closest('[data-cte-eye]')) {
        var hl = itemsOf().filter(function (x) { return x.id === li.dataset.id; })[0];
        return hl && patchLayer(hl.id, { hidden: !hl.hidden });
      }
      if (li && t.closest('[data-cte-del]')) return removeLayer(li.dataset.id);
      if (li && (el = t.closest('[data-cte-lmove]'))) return moveLayerTo(li.dataset.id, qa('.cte-layer').indexOf(li) + Number(el.dataset.cteLmove));
    });
    /* Móvil: hoja «Ver cómo queda puesta» con la vista previa de la foto; se cierra volviendo al editor. */
    function openSheet(opener) {
      sheetOpener = opener;
      sheet.hidden = false;
      document.documentElement.classList.add('cte-noscroll');
      renderPreviews();
      sheet.querySelector('[data-cte-sheet-close]').focus();
    }
    function closeSheet() {
      if (sheet.hidden) return;
      sheet.hidden = true;
      document.documentElement.classList.remove('cte-noscroll');
      if (sheetOpener) sheetOpener.focus();
    }
    sheet.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeSheet(); } });
    q('[data-cte-measures]').addEventListener('change', function (e) { showMeasures = e.target.checked; requestRender(); });
    q('[data-cte-hood]').addEventListener('click', function () { hoodMode = HOOD_NEXT[hoodMode]; syncHood(); requestRender(); });
    cotaInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); if (commitCota()) cotaBtn.focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); closeCota(); cotaBtn.focus(); }
    });
    /* al salir con un valor no válido se mantiene la distancia anterior (sigue siendo obligatoria) y queda el aviso */
    cotaInput.addEventListener('blur', function () { if (!cotaEdit.hidden && !commitCota()) closeCota(true); });
    q('[data-cte-dx]').addEventListener('change', function (e) {
      var g = activeGroup(), parsed = IO.parseCm(e.target.value, -DX_MAX, DX_MAX), bad = parsed.empty || parsed.invalid;
      e.target.setAttribute('aria-invalid', String(bad));
      posMsg(bad ? 'El desplazamiento debe estar entre −' + DX_MAX + ' y +' + DX_MAX + ' cm (0 = centrado).' : '');
      if (bad || !g) return;
      if (shiftGroupLimited(g, parsed.value - designRect(state.tab, g).cu, 0)) posMsg(LIMIT_MSG);
    });
    root.addEventListener('keydown', function (e) {
      var grip = e.target.closest && e.target.closest('[data-cte-grip]');
      if (!grip || (e.key !== 'ArrowUp' && e.key !== 'ArrowDown')) return;
      e.preventDefault();
      var li = grip.closest('.cte-layer'), idx = qa('.cte-layer').indexOf(li);
      moveLayerTo(li.dataset.id, idx + (e.key === 'ArrowUp' ? -1 : 1));
      var again = q('.cte-layer[data-id="' + li.dataset.id + '"] [data-cte-grip]');
      if (again) again.focus();
    });
    SU = window.CorexTextilSizeUI.attach({
      root: root, canvas: canvas, metrics: function () { return metrics; }, tab: function () { return state.tab; },
      isFlat: function () { return isFlat(state.tab); }, itemsOf: function () { return itemsOf(); }, selectedIds: selectedIds,
      size: function () { return state.size; }, limit: function (top) { return refLimit(state.tab, top); }, useful: moveLimits,
      setItems: setItems, lockReason: lockReason, dragging: function () { return dragging; }, posMsg: posMsg, announce: announce,
      refresh: placeOverlay
    });
    window.CorexTextilPointer.attach({
      root: root, canvas: canvas,
      state: function () { return state; }, metrics: function () { return metrics; }, resetList: function () { listKey = ''; },
      qa: qa, update: update, setState: setState, lockReason: lockReason, activePrint: activePrint, selected: selected,
      itemOf: itemOf, selectOnly: selectOnly, toggleSel: toggleSel, isMulti: isMulti, patchLayer: patchLayer,
      patchLayerLive: patchLayerLive, removeLayer: removeLayer, moveLayerTo: moveLayerTo, scaleFrom: scaleFrom, clampMove: clampMove,
      scaleAnchor: function (l) { return SU.anchorOf(l); },
      rotatePatch: function (l, deg) { return SU.rotatePatch(l, deg); },
      onDrag: function (on) { dragging = on; root.classList.toggle('is-dragging-el', on); if (on) floatEl.hidden = true; }
    });
    text = window.CorexTextilText.attach({ root: root, selected: selected, patchLayer: patchLayer, fontLoaded: fontLoaded, announce: announce, lockReason: lockReason });
    q('[data-cte-file]').addEventListener('change', function (e) {
      var file = e.target.files && e.target.files[0];
      e.target.value = '';
      readFile(file);
    });
    q('[data-cte-guide]').innerHTML = UI.guide(sizesOrder, data.medidas);
    if (window.ResizeObserver) new ResizeObserver(function () { requestRender(); }).observe(q('[data-cte-stage]'));
    else window.addEventListener('resize', requestRender);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { listKey = ''; update(); });
    /* Barra inferior móvil: mientras el personalizador (editor y pedido) está a la vista. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) { root.classList.toggle('is-inview', entries[0].isIntersecting); }).observe(q('.cte-inner'));
    }
    /* Lectura del diseño para el pedido (copia: el editor sigue siendo el dueño del estado). Las vistas salen con
       sus impresiones ya formadas ({ on, prints }), como las ha leído siempre el pedido. */
    root.cteGetDesign = function () {
      var out = JSON.parse(JSON.stringify(state));
      out.views = VIEWS.reduce(function (acc, v) {
        acc[v.id] = { on: hasDesign(v.id), prints: prints(v.id).map(function (p) { return { id: p.id, size: p.size, dist: p.dist, dx: p.dx, layers: p.layers }; }) };
        return acc;
      }, {});
      return JSON.parse(JSON.stringify(out));
    };
    root.cteSetColor = function (name) {
      if (name !== state.color && data.colors.some(function (c) { return c.name === name; })) setState({ color: name });
    };
    /* Fuentes de todos los textos cargadas (antes de generar los PNG). */
    root.cteFontsReady = function () {
      return F.ensureLayers(VIEWS.reduce(function (acc, v) { return acc.concat(itemsOf(v.id)); }, [])).then(function () { fontsVersion++; storeDerived(); });
    };
    /* ---------- archivos de producción (corex-textil-editor-export.js) ---------- */
    window.CorexTextilExport.attach(root, {
      prints: prints, sizeIndex: function (t) { return productSizes.indexOf(t); }, refSize: function () { return state.size; },
      /* fila de la tabla por talla de una impresión (ancho entero y escala real de esa talla) */
      printRow: function (viewId, printId, talla) {
        var r = ((state.medidasPorTalla || {})[viewId] || []).filter(function (x) { return x.talla === talla; })[0];
        return r ? r.impresiones.filter(function (x) { return x.id === printId; })[0] || null : null;
      },
      getImage: getImage, loadColor: GM.load, views: VIEWS, frameFor: frameFor, drawBase: drawBase, drawWarped: drawWarped,
      renderArea: renderArea, drawSleevesOnFront: drawSleevesOnFront,
      withPaint: function (color, fn) { paintOverride = color; try { return fn(); } finally { paintOverride = null; } }
    });
    root.cteSetOrder = function (pedido) { state = Object.assign({}, state, { pedido: pedido }); };
    /* El pedido fija la talla de cobro (la mayor con cantidad; null = la de referencia). */
    root.cteSetBillingSize = function (talla) {
      var t = talla && productSizes.indexOf(talla) !== -1 ? talla : null;
      if (t !== (state.tallaCobro || null)) setState({ tallaCobro: t });
    };
    /* ---------- «Mis diseños»: cargar un diseño guardado (corex-textil-disenos.js) ----------
       doc: JSON del diseño (CorexTextilCart.designDoc). Restaura zonas, elementos, distancias, talla de referencia y
       color; la matriz del pedido no se toca. En otra prenda o talla cada diseño se reduce al máximo y se mueve dentro
       del límite útil (CorexTextilDisenosModel.fitView). Resuelve { avisos, perdidas (zonas que esta prenda no tiene),
       talla }. */
    root.cteApplyDesign = function (doc) {
      var DM = window.CorexTextilDisenosModel, SZ = window.CorexTextilSizing;
      var src = DM.itemsFromDoc(doc), pick = DM.pickRefSize(doc.tallaReferencia, productSizes);
      var perdidas = Object.keys(src).filter(function (id) { return !VIEW[id]; });
      var all = Object.keys(src).reduce(function (acc, id) { return acc.concat(src[id].items); }, []);
      /* los textos se miden con su fuente: hay que tenerla antes de calcular topes */
      return F.ensureLayers(all).catch(function () { return null; }).then(function () {
        fontsVersion++;
        var size = pick.talla, avisos = [];
        if (pick.cambiada) avisos.push('Esta prenda no tiene la talla ' + doc.tallaReferencia + ': el diseño se ha colocado sobre la talla ' + size + '.');
        var sleeve = M.printSize(M.SLEEVE_SIZE);
        var views = VIEWS.reduce(function (acc, v) {
          var s = src[v.id];
          if (!s) { acc[v.id] = { items: [], dist: v.kind === 'sleeve' ? v.defaultDist : null }; return acc; }
          var lim = limitsBySize(v.id)[size];
          var fit = DM.fitView({
            label: v.label, kind: v.kind, items: s.items, talla: size,
            limit: function (top) { return M.sizeLimit(v.kind, medFor(size), lim, top); },
            bounds: v.kind === 'sleeve' ? { x0: -sleeve.w / 2, x1: sleeve.w / 2, y0: -sleeve.h / 2, y1: sleeve.h / 2 }
              : GM.useful(v.id, size, { chest: M.CHEST_MARGIN_CM, hem: M.HEM_MARGIN_CM, neck: M.NECK_MARGIN_CM, armhole: M.ARMHOLE_MARGIN_CM })
          }, {
            corners: G.layerCorners, scaleLayers: SZ.scaleLayers, clampShift: A.clampShift,
            derive: function (items) { return GR.derivePrints({ viewId: v.id, items: items, corners: G.layerCorners, size: M.FREE_AREA, areaH: free.h }); }
          });
          avisos = avisos.concat(fit.avisos);
          acc[v.id] = { items: fit.items, dist: v.kind === 'sleeve' ? (s.dist == null ? v.defaultDist : s.dist) : null };
          return acc;
        }, {});
        var color = data.colors.some(function (c) { return c.name === doc.color; }) ? doc.color : state.color;
        var first = VIEWS.filter(function (v) { return views[v.id].items.length; })[0];
        printsMemo = {};
        listKey = '';
        setState({ size: size, color: color, views: views, tab: first ? first.id : VIEWS[0].id, printId: null, sel: null, selIds: [] });
        return { avisos: avisos, perdidas: perdidas, talla: size };
      });
    };
    update();
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-cte]'), init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
